import Icons from "../Icons/Icons";
import {Link} from "react-router-dom";
import Config from "../../config";

const Card = (props) => {

    const cardBody = ["card--shadow", "px--6", "py--6", "w100"];
    let url = `/` + props.slug;

    if (props.parent_slug) {
        url = "/" + props.parent_slug + url
    }

    if (props.short) {
        cardBody.push("card--short")
    }

    const body = props.nobody ? null : ( props.body_short ?? null );

    return (
        <Link to={url} className={"card flex--column flex flex--middle flex--end"}>
            {
                props.src && <img src={`${Config.urlPublic}/${props.controller}/main/${props.src}`}
                                  alt={props.name}
                                  loading={"lazy"}
                                  height={275}
                                  className={"card__image"}
                />
            }
            <div className={cardBody.join(" ")}>
                <h2 className={"mb--6 card__title"}>{props.name}</h2>
                {body &&
                <div className={`card__body ${props.notruncate ? `` : `ellipsis`} mb--6`}
                     dangerouslySetInnerHTML={{__html: body}}></div>}
                <span className={"btn btn--icon btn--border w100"}>
                                    Dowiedz się więcej
                                    <Icons name={"right-long"}/>
                                </span>
            </div>
        </Link>
    )

}

export default Card
